import { useCallback, useState } from "react";
import adminApi from "../api/adminApi";
import { isSameData } from "../utils/adminUtils";

export default function useCampuses(setBanner) {
  const [campuses, setCampuses] = useState([]);
  const [campusesLoading, setCampusesLoading] = useState(false);

  const loadCampuses = useCallback(async (silent = false) => {
    if (!silent) setCampusesLoading(true);

    try {
      const data = await adminApi.getCampuses();
      const next = Array.isArray(data) ? data : [];
      setCampuses((prev) => (isSameData(prev, next) ? prev : next));
    } catch (error) {
      setBanner({ type: "error", text: error.message || "Failed to load campuses" });
    } finally {
      if (!silent) setCampusesLoading(false);
    }
  }, [setBanner]);

  return {
    campuses,
    campusesLoading,
    loadCampuses,
  };
}